import {AxiosPromise} from 'axios';

import {backend} from '../../utils/_config/axios';

export default class SignatureService {
    public getMintSignature(instanceId: number, walletAddress: string): AxiosPromise<{signature: string}> {
        return backend(true).get(`/api/signature/mint?instance=${instanceId}&recipient=${walletAddress}`);
    }
}
